import UserHomeworkShow from "./UserHomeworkShow";
import UserHomeworkList from "./UserHomeworkList";
import UserHomeworkEdit from "./UserHomeworkEdit";

export default {
  list: UserHomeworkList,
  edit: UserHomeworkEdit,
  show: UserHomeworkShow,
};
